<script setup lang="ts" generic="T extends string">
const props = defineProps<{
  product: SingleProduct
  gradeOptions?: Options<T, { grades?: GradeCode[] }>
  filterKey: 'grade' | 'level'
}>()

const enabled = computed(() => {
  const formats = new Set<string>()
  const grades = new Set<string>()
  const languages = new Set<string>()

  for (const variant of props.product.variants) {
    if (variant.formats) {
      for (const format of variant.formats) {
        formats.add(format)
      }
    }

    if (variant.grades && props.gradeOptions) {
      for (const grade of variant.grades) {
        const option = props.gradeOptions.find(
          (it) => it.grades?.includes(grade) || it.value === grade,
        )

        if (option) {
          grades.add(option.value)
        }
      }
    }

    if (variant.languages) {
      for (const lang of variant.languages) {
        languages.add(lang)
      }
    }
  }

  return { formats, grades, languages }
})

const templateClass = computed(() => {
  switch (props.product.template) {
    case 'standard2':
      return 'rounded-tr-(--roundness) lg:rounded-tr-none rounded-bl-(--roundness) md:gap-4! lg:-mt-16'

    default:
      return 'md:w-fit -mt-16'
  }
})
</script>

<template>
  <UiFilterContainer
    class="mx-auto bg-(--filter-background) p-6 text-(--filter-color) sm:px-16 sm:py-8 lg:px-24 lg:py-12"
    :class="templateClass"
    title="Hva vil du se?"
    :filters="
      [
        gradeOptions
          ? {
            name: filterKey,
            legend: 'TRINN',
            enabled: enabled.grades,
            options: gradeOptions,
          }
          : undefined,
        {
          name: 'language',
          legend: 'MÅLFORM',
          enabled: enabled.languages,
          options: [
            { value: 'nob', title: 'Bokmål', tagName: 'Bokmål' },
            { value: 'nno', title: 'Nynorsk', tagName: 'Nynorsk' },
          ],
        },
        {
          name: 'format',
          legend: 'PRODUKTTYPE',
          enabled: enabled.formats,
          options: PRODUCT_FORMAT_OPTIONS,
        },
      ].filter(truthy)
    "
  >
    <template
      v-if="product.template === 'standard2'"
      #title
    >
      <h2
        class="font-headline text-xl font-medium md:text-2xl"
      >
        Hva vil du se?
      </h2>
    </template>
  </UiFilterContainer>
</template>
